import { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

import { usePagedList } from "../../hook/usePagedList";
import Pager from "./Pager";

const PER_PAGE_OPTIONS = [10, 25, 50, 100];

/**
 * One paged sub-list of a record page (person, account): loading, empty, rows
 * and the page foot, the same on every tab so the tabs read as one page.
 * `reloadKey` changing re-fetches, e.g. after an action on the page.
 */
const PagedTable = ({ path, params, head, row, empty, emptyIcon, reloadKey }) => {
  const [perPage, setPerPage] = useState(10);
  const { rows, count, loading, error, page, setPage, totalPages, reload } = usePagedList(
    path,
    params,
    perPage,
  );
  useEffect(() => {
    if (reloadKey) reload();
  }, [reloadKey, reload]);

  if (loading)
    return (
      <div className="ms-state">
        <div className="ms-spinner" />
      </div>
    );
  if (error)
    return (
      <div className="ms-state">
        <Icon icon="tabler:alert-triangle" />
        <span>{error}</span>
      </div>
    );
  if (rows.length === 0)
    return (
      <div className="ms-state">
        <Icon icon={emptyIcon} />
        <span>{empty}</span>
      </div>
    );
  return (
    <>
      <div className="ms-table-wrap">
        <table className="ms-table ms-table--compact">
          <thead>{head}</thead>
          <tbody>{rows.map(row)}</tbody>
        </table>
      </div>
      <div className="ms-tablefoot">
        <span className="ms-tablefoot-count">
          Jami <b>{count}</b> ta
        </span>
        <div className="ms-tablefoot-right">
          <label className="ms-perpage">
            <span>Koʻrsatish</span>
            <select
              className="ms-select ms-select--sm"
              value={perPage}
              onChange={(e) => setPerPage(Number(e.target.value))}
            >
              {PER_PAGE_OPTIONS.map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>
          <Pager page={page} totalPages={totalPages} onPage={setPage} />
        </div>
      </div>
    </>
  );
};

export default PagedTable;
